// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function Label$BaseLabel(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "md";
  let sizeClass = size === "lg" ? "px-3 py-1" : "px-2.5 py-0.5";
  return JsxRuntime.jsx("span", {
    children: props.children,
    className: TailwindMerge.twMerge([
      "rounded-full font-medium whitespace-nowrap text-[13px]",
      sizeClass,
      props.className
    ])
  });
}

function Label$Positive(props) {
  return JsxRuntime.jsx(Label$BaseLabel, {
    size: props.size,
    className: "bg-green-50 text-green-700",
    children: props.text
  });
}

let Positive = {
  make: Label$Positive
};

function Label$Neutral(props) {
  let __variant = props.variant;
  let variant = __variant !== undefined ? __variant : "default";
  let bgColor = variant === "default" ? "bg-gray-200" : "bg-gray-50";
  return JsxRuntime.jsx(Label$BaseLabel, {
    size: props.size,
    className: bgColor + " text-gray-700",
    children: props.text
  });
}

let Neutral = {
  make: Label$Neutral
};

function Label$Info(props) {
  return JsxRuntime.jsx(Label$BaseLabel, {
    size: props.size,
    className: "bg-blue-100 text-blue-900",
    children: props.text
  });
}

let Info = {
  make: Label$Info
};

function Label$Warning(props) {
  return JsxRuntime.jsx(Label$BaseLabel, {
    size: props.size,
    className: "bg-yellow-100 text-yellow-900",
    children: props.text
  });
}

let Warning = {
  make: Label$Warning
};

function Label$Danger(props) {
  return JsxRuntime.jsx(Label$BaseLabel, {
    size: props.size,
    className: "bg-red-100 text-red-900",
    children: props.text
  });
}

let Danger = {
  make: Label$Danger
};

exports.Positive = Positive;
exports.Neutral = Neutral;
exports.Info = Info;
exports.Warning = Warning;
exports.Danger = Danger;
/* tailwind-merge Not a pure module */
